import { render, staticRenderFns } from "./AwardBanner.vue?vue&type=template&id=9bb06622&scoped=true&"
import script from "./AwardBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AwardBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AwardBanner.vue?vue&type=style&index=0&id=9bb06622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb06622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bb06622')) {
      api.createRecord('9bb06622', component.options)
    } else {
      api.reload('9bb06622', component.options)
    }
    module.hot.accept("./AwardBanner.vue?vue&type=template&id=9bb06622&scoped=true&", function () {
      api.rerender('9bb06622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AwardBanner/AwardBanner.vue"
export default component.exports